import { css } from 'lit';
import { hostReset } from '../styles/mixins.js';

export default [
  hostReset,
  css`
    :host {
      display: block;
    }

    form {
      display: contents;
    }
  `,
];
